/** Where a conversation sources its code: the current checkout, a local branch, or a remote branch. */
export type CloudHandoffSource =
  | { type: 'workspace' }
  | { type: 'local'; branch: string }
  | { type: 'remote'; branch: string };

export function cloudHandoffScope(source: CloudHandoffSource | null): 'local' | 'remote' {
  return source?.type === 'remote' ? 'remote' : 'local';
}

export function cloudHandoffBranchName(source: CloudHandoffSource): string | null {
  return source.type === 'workspace' ? null : source.branch;
}

export function usesWorkspaceSnapshot(source: CloudHandoffSource, currentBranch: string): boolean {
  return (
    source.type === 'workspace' || (source.type === 'local' && source.branch === currentBranch)
  );
}
